class ProductFormDry3 extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    if (!this.form) return;

    const optionsDataScript = this.querySelector('script.js-corresponding-products-data');
    if (optionsDataScript) {
      try {
        this.optionsData = JSON.parse(optionsDataScript.textContent);
        console.log(this.optionsData)
      }
      catch(err) {
        console.log('error', err)
      }
    }
    this.submitButton = this.querySelector('[type="submit"]');
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.initBundleInputs();
    this.initOptions();
  }

  emitSelection(variantId) {
    const data = this.optionsData?.[variantId];
    if (!data) return;

    this.dispatchEvent(new CustomEvent("dry:variant-selected", {
      bubbles: true,
      detail: { variantId, data },
    }));
  }

  initBundleInputs() {
    const inputsWrapper = this.getInputsWrapper();
    if (!inputsWrapper) return;

    const activeVariantId = inputsWrapper.dataset.activeVariantId;
    const data = this.optionsData?.[activeVariantId];
    if (!data?.bundleAppProxy) return;

    this.enrichBundleInputs(inputsWrapper, data);
  }

  initOptions() {
    const optionsList = this.querySelector('[data-corresponding-options]');
    const options = optionsList?.querySelectorAll('[data-corresponding-option]');
    if (!options?.length) return;

    const updateHistory = (option) => {
      const href = option?.href;
      if (!href) return;

      history.replaceState(null, "", href);
    }

    const updateSelection = (newSelection) => {
      if (!newSelection) return;

      for (const option of options) {
        option.removeAttribute('aria-selected');
      }
      newSelection.setAttribute('aria-selected', "true");
    }

    const optionsData = this.optionsData;
    const updateInputs = (newSelection) => {
      if (!newSelection) return;

      const template = newSelection.querySelector('template');
      if (template) {
        const fragment = document.importNode(template.content, true);

        // Bundles require an ID from Recharge client script
        if ('bundle' === newSelection.dataset.type) {          
          const data = optionsData?.[newSelection.dataset.variantId];
          if (data) {
            this.enrichBundleInputs(fragment, data);
          }
        }

        this.setInputs(fragment, newSelection.dataset.variantId);
      }
      else {
        console.log('no template :(');
        this.clearInputs();
      } 
    }

    optionsList.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('click', e)

      const clickedOption = e.target.closest('[data-corresponding-option]');
      if (!clickedOption) return;

      updateSelection(clickedOption);
      updateInputs(clickedOption);
      updateHistory(clickedOption);
      this.emitSelection(clickedOption.dataset.variantId);
    })
  }

  getInputsWrapper() {
    return this.querySelector('.js-product-form-inputs');
  }

  clearInputs() {
    const wrapper = this.getInputsWrapper();
    if (!wrapper) return;

    wrapper.innerHTML = '';

    // remove wrapper attributes??
  }

  setInputs(fragment, variantId) {
    const wrapper = this.getInputsWrapper();
    if (!wrapper || !fragment) return;

    wrapper.innerHTML = '';
    wrapper.appendChild(fragment);

    wrapper.dataset.activeVariantId = variantId;
  }

  enrichBundleInputs(wrapperNode, optionData) {
    const bundleAppProxy = optionData?.bundleAppProxy;
    const productHandle = optionData?.handle;
    if (!bundleAppProxy || !productHandle) wrapperNode;

    const dynamicBundle = window.recharge?.bundle?.getDynamicBundleItems(bundleAppProxy, productHandle);
    const bundleId = dynamicBundle?.[0]?.properties._rc_bundle; // don't know why this is an array
    if (bundleId) {
      wrapperNode.querySelectorAll('[name$="[_rc_bundle]"]').forEach(input => input.value = bundleId);

      const now = Date.now();
      wrapperNode.querySelectorAll('[name$="[_bundle_id]"]').forEach(input => input.value = now);
    }

    return wrapperNode;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    if (localStorage.getItem("shippingRates") != null) {
      localStorage.removeItem("shippingRates");
    }

    if (document.body.classList.contains("is-petzyo-plan") && this.submitButton.classList.contains("product-petzyo-plan")) {
      this.submitButton.classList.add("js-update-cart");
    }

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    // this.enrichBundleData();
    const updateFormData = this.getUpdateFormData();
    updateFormData ? this.updateProductInCart(updateFormData) : this.addProduct();
  }

  enrichBundleData() {
    if (!window.recharge || !window.recharge.bundle || !window.recharge.bundle.getDynamicBundleItems) {
      console.warn('[bundle] recharge.bundle.getDynamicBundleItems unavailable — falling back to default form fields');
      return;
    }

    // Parse items[N][...] inputs into a structured selections array
    const parsed = [];
    const formData = new FormData(this.form);
    for (const [key, value] of formData.entries()) {
      const m = key.match(/^items\[(\d+)\](?:\[([^\]]+)\](?:\[([^\]]+)\])?)?$/);
      if (!m) continue;
      const idx = parseInt(m[1], 10);
      const outerKey = m[2];
      const innerKey = m[3];
      parsed[idx] = parsed[idx] || { properties: {} };
      if (outerKey === 'properties' && innerKey) {
        parsed[idx].properties[innerKey] = value;
      } else if (outerKey) {
        parsed[idx][outerKey] = value;
      }
    }

    const hasBundles = parsed.length > 0;
    !hasBundles && console.log('no bundles')
    if (!hasBundles) return;

    // data-productid is an attribute on the id input — not in form data
    this.form.querySelectorAll('input[name^="items["][name$="[id]"]').forEach((input) => {
      const m = input.name.match(/^items\[(\d+)\]\[id\]$/);
      if (!m) return;
      const idx = parseInt(m[1], 10);
      if (parsed[idx]) parsed[idx]._externalProductId = input.dataset.productid;
    });

    // Parent bundle info is on every item's properties — read from the first
    const props = (parsed[0] && parsed[0].properties) || {};
    const productHandle = props._rc_bundle_parent;
    const parentVariantId = props._rc_bundle_variant;
    const collectionId = props._rc_bundle_collection_id;
    const parentProductId = props._externalProductId || formData.get('product-id') || this.form.dataset.product;

    if (!productHandle || !parentVariantId || !parentProductId) {
      console.warn('[bundle] missing parent bundle info — skipping enrichment');
      return;
    }

    const bundle = {
      externalProductId: String(parentProductId),
      externalVariantId: String(parentVariantId),
      selections: parsed.map((item) => ({
        collectionId: String(collectionId),
        externalProductId: String(item._externalProductId || ''),
        externalVariantId: String(item.id),
        quantity: parseInt(item.quantity, 10) || 1,
        sellingPlan: item.selling_plan ? parseInt(item.selling_plan, 10) : null,
      })),
    };

    const enrichedItems = window.recharge.bundle.getDynamicBundleItems(bundle, productHandle);

    // Bundle id: use _rc_bundle from Recharge if present, otherwise current timestamp.
    // Same value across all items so they're grouped as one bundle instance.
    const rcBundle = enrichedItems.find((it) => it && it.properties && it.properties._rc_bundle);
    const bundleId = (rcBundle && rcBundle.properties._rc_bundle) || String(Date.now());

    // Update or insert items[N][...] inputs based on enriched data.
    // Existing inputs are reused (value updated); new fields are appended.
    const upsertInput = (name, value) => {
      let input = this.form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.dataset.bundleEnriched = 'true';
        this.form.appendChild(input);
      }
      input.value = value;
    };

    enrichedItems.forEach((item, i) => {
      if (item.id != null) upsertInput(`items[${i}][id]`, item.id);
      if (item.quantity != null) upsertInput(`items[${i}][quantity]`, item.quantity);
      if (item.selling_plan != null) upsertInput(`items[${i}][selling_plan]`, item.selling_plan);
      if (item.properties) {
        Object.entries(item.properties).forEach(([k, v]) => {
          if (v != null) upsertInput(`items[${i}][properties][${k}]`, v);
        });
      }
      upsertInput(`items[${i}][properties][_bundle_id]`, bundleId);
    });
  }

  getUpdateFormData() {
    if (!this.submitButton.classList.contains("js-update-cart")) return null;

    const variantId = this.form.querySelector('[name="id"]')?.value;
    if (!variantId) return null;

    const referenceButton = document.querySelector(`minicart-remove[data-variant="${variantId}"]`);
    if (!referenceButton) return null;

    const line = referenceButton.getAttribute("data-line");
    const qty = referenceButton.getAttribute("data-qty");
    if (!line || !qty) return null;

    const qtyInput = this.form.querySelector('.js-product-qty-input');
    const qtyAdd = qtyInput ? parseInt(qtyInput.value) : 1;

    return {
      line: parseInt(line),
      quantity: parseInt(qty) + qtyAdd,
    };
  }

  addProduct() {
    const formData = new FormData(this.form);

    const dogField = JSON.parse(localStorage.getItem("dogsField") || "[]");
    if (localStorage.getItem("dogsField") != null && dogField.length > 0) {
      formData.set("properties[_dog_fields]", localStorage.getItem("dogsField"));
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (document.body.classList.contains("is-petzyo-plan")) {
          this.dogsField = JSON.parse(localStorage.getItem("dogsField"));
          if (localStorage.getItem("dogsField") != null && this.dogsField.length > 0) {
            localStorage.setItem("changeProduct", true);
          }
        }
        if (this.submitButton.classList.contains('js-add-free-product') && document.querySelectorAll('.js-promotional-product-data').length > 0) {
          if (document.querySelector('.js-promotional-product-data').getAttribute('data-available') == 'true') {
            let freeId = document.querySelector('.js-promotional-product-data').getAttribute('data-variant');
            if (freeId) {
              let freeFormData = {
                'items': [{
                  'id': freeId,
                  'quantity': 1
                }]
              };
              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(freeFormData)
              })
                .then((response) => {
                  const minicart = document.querySelector("mini-cart");
                  minicart.renderCart(this.submitButton, true);
                })
                .catch((error) => {
                  console.error("Error:", error);
                  this.submitButton.classList.remove("js-update-cart");
                  this.submitButton.classList.remove("loading");
                  this.submitButton.removeAttribute("aria-disabled");

                  alert(window.cartStrings.error);
                });
            }
          }
        }
        const minicart = document.querySelector("mini-cart");
        minicart.renderCart(this.submitButton, true);
      })
      .catch((error) => {
        console.log(error);
        this.submitButton.classList.remove("js-update-cart");
        this.submitButton.classList.remove("loading");
        this.submitButton.removeAttribute("aria-disabled");

        alert(window.cartStrings.error);
      });
  }

  updateProductInCart(formData) {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        const minicart = document.querySelector("mini-cart");
        minicart.renderCart(this.submitButton, true);
      })
      .catch((error) => {
        console.log(error);
        this.submitButton.classList.remove("loading");
        this.submitButton.removeAttribute("aria-disabled");

        alert(window.cartStrings.error);
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define("product-form-dry-multi", ProductFormDry3);


class ProductDryBundleInputs extends HTMLElement {
  constructor() {
    super();

    this.populateBundleIds();
  }

  populateBundleIds() {
    // const 
  }

  // TODO: update inputs with Recharge bundle ID
}

customElements.define("product-dry-bundle-inputs", ProductDryBundleInputs);

class CustomImages extends HTMLElement {
  constructor() {
    super();

    this.slide = this;

    let dot = false;
    if (this.slide.hasAttribute("data-dots")) {
      dot = this.slide.getAttribute("data-dots");
    }
    this.flkty = new Flickity(this.slide, {
      cellAlign: "left",
      pageDots: dot,
      adaptiveHeight: false,
      prevNextButtons: false,
      fade: true,
      imagesLoaded: true,
    });

    if (this.hasAttribute("data-id")) {
      this.id = this.getAttribute("data-id");
      if (this.id) {
        this.nav = document.querySelector('.js-slider-thumbnails[data-id="' + this.id + '"]');
      }
    } else {
      this.nav = document.querySelector(".js-slider-thumbnails");
    }

    if (this.nav) {
      this.nav.querySelectorAll(".product-thumbnails-item").forEach((button) => button.addEventListener("click", this.onChangeSlide.bind(this)));
    }

    this.flkty.on("change", function (index) {
      this.nav = document.querySelector(".js-slider-thumbnails.selected");
      if (this.nav) {
        if (this.nav.querySelectorAll('.product-thumbnails-item[data-index="' + index + '"]').length > 0) {
          this.nav.querySelector(".product-thumbnails-item.slide-current").classList.remove("slide-current");
          this.nav.querySelector('.product-thumbnails-item[data-index="' + index + '"]').classList.add("slide-current");
        }
      }
    });
  }

  onChangeSlide(e) {
    if (e.target.closest(".product-thumbnails-item")) {
      this.nextIndex = e.target.closest(".product-thumbnails-item").getAttribute("data-index");
      if (this.nextIndex) {
        this.flkty.select(this.nextIndex);
      }
    }
  }
}

customElements.define("custom-images", CustomImages);

class CustomVariants extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector("select");
    if (!this.select) return;

    this.select.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantChange(e) {
    if (document.querySelectorAll(".product-custom-raw").length > 0) {
      this.dataColor = e.target.options[e.target.selectedIndex].getAttribute("data-color");
      const classes = ["green", "yellow", "purple"];
      classes.forEach((c) => {
        if (document.querySelector(".product-custom-raw").classList.contains(c)) {
          document.querySelector(".product-custom-raw").classList.remove(c);
        }
      });
      document.querySelector(".product-custom-raw").classList.add(this.dataColor);
    }

    this.id = e.target.options[e.target.selectedIndex].getAttribute("data-slide");
    if (document.querySelectorAll('custom-images[data-id="' + this.id + '"]').length > 0) {
      document.querySelector("custom-images.selected").classList.remove("selected");
      document.querySelector('custom-images[data-id="' + this.id + '"]').classList.add("selected");
    }
    if (document.querySelectorAll('.js-slider-thumbnails[data-id="' + this.id + '"]').length > 0) {
      document.querySelector(".js-slider-thumbnails.selected").classList.remove("selected");
      document.querySelector('.js-slider-thumbnails[data-id="' + this.id + '"]').classList.add("selected");
    }
    if (document.querySelectorAll('.desc-product-wrap[data-id="' + this.id + '"]').length > 0) {
      document.querySelectorAll(".desc-product-wrap.active").forEach((elm) => elm.classList.remove("active"));
      document.querySelectorAll('.desc-product-wrap[data-id="' + this.id + '"]').forEach((elm) => elm.classList.add("active"));
      // document.querySelector('.desc-product-wrap.active').classList.remove('active');
      // document.querySelector('.desc-product-wrap[data-id="'+ this.id +'"]').classList.add('active');
    }
  }
}

customElements.define("custom-variants", CustomVariants);

class ShowDescription extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    document.querySelectorAll(".desc-product-wrap.active .description-truncate").forEach((elm) => (elm.style.display = "none"));
    document.querySelectorAll(".desc-product-wrap.active .description-full").forEach((elm) => (elm.style.display = "block"));
    // document.querySelector('.desc-product-wrap.active .description-truncate').style.display = 'none';
    // document.querySelector('.desc-product-wrap.active .description-full').style.display = 'block';
  }
}

customElements.define("show-description", ShowDescription);

class ProductReview extends HTMLElement {
  constructor() {
    super();

    var elem = this;
    var flkty = new Flickity(elem, {
      // options
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 10000,
      wrapAround: true,
    });
  }
}

customElements.define("product-review", ProductReview);

class DryReview extends HTMLElement {
  constructor() {
    super();
    (this.columnSelector = ".review-column"),
      (this.blockSelector = ".review-block"),
      (this.type = "horizonal"),
      (this.repeat = 1),
      (this.timing = this.dataset.timing ? Number(this.dataset.timing) : 16),
      (this.delay = 0),
      (this.staggered = "true" == this.dataset.staggered),
      (this.columns = this.querySelectorAll(this.columnSelector)),
      (this.started = !1),
      this.columns.forEach((e, t) => {
        const i = e.querySelector(this.blockSelector);
        this.handleLoop(e, i, t);
      });
  }

  animateTickertape(e, t, i) {
    const s = i.count,
      r = e,
      { distance: n } = i;
    let o = s + 1;
    (r.style.transitionTimingFunction = "linear"),
      (r.style.transitionProperty = "all"),
      "vertical" == this.type && this.staggered
        ? (1 === o && (o = 1),
          2 === o && (o = 4),
          3 === o && (o = 3),
          4 === o && (o = 2),
          (r.style.transitionDuration = (o + 1) * this.timing + "s"),
          (r.style.transform = `translate3d(0, -${n}px, 0)`))
        : "vertical" == this.type
          ? ((r.style.transitionDuration = `${this.timing}s`), (r.style.transform = `translate3d(0, -${n}px, 0)`))
          : ((r.style.transitionDuration = `${this.timing}s`), (r.style.transform = `translate3d(-${n}px, 0,  0)`));
    const a = this.staggered ? (o + 1) * (1e3 * this.timing) : 1e3 * this.timing;
    window.setTimeout(() => {
      (r.style.transitionDuration = "0s"), (r.style.transform = "translate3d(0, 0 ,0)"), this.handleLoop(e, t, s);
    }, a);
  }

  handleLoop(e, t, i) {
    if (this.started) {
      let s = "vertical" == this.type ? e.getBoundingClientRect().height : t.getBoundingClientRect().width;
      this.repeat && (s *= this.repeat),
        this.animateTickertape(e, t, {
          distance: s,
          count: i,
        });
    } else
      setTimeout(() => {
        this.started = !0;
        let s = "vertical" == this.type ? e.getBoundingClientRect().height : t.getBoundingClientRect().width;
        this.repeat && (s *= this.repeat),
          this.animateTickertape(e, t, {
            distance: s,
            count: i,
          });
      }, this.delay);
  }
}

customElements.define("dry-review", DryReview);

class DrySticky extends HTMLElement {
  constructor() {
    super();
    this.sticky = this;
    this.container = this.sticky.closest('.product-custom-info-wrap');

    if (!this.container) return;

    const callback = (entries, observer) => {
      for (const entry of entries) {
        if (!document.body.classList.contains('product-popup-opening')) {
          entry.isIntersecting ? this.sticky.classList.remove('active') : window.scrollY > 200 && this.sticky.classList.add('active');
        }
      }
    }
    const observer = new IntersectionObserver(callback, {
      threshold: 0.25,
    });
    observer.observe(this.container)
  }
}

customElements.define("dry-sticky", DrySticky);

class ProductStickyAtc extends HTMLElement {
  connectedCallback() {
    this.productForm = document.querySelector("product-form-dry-multi");
    if (!this.productForm) return;

    this.nameEl = this.querySelector("[data-sticky-name]");
    this.weightEl = this.querySelector("[data-sticky-weight]");
    this.priceEl = this.querySelector("[data-sticky-price]");
    this.button = this.querySelector("[data-sticky-atc]");
    this.ratingLockupEl = this.querySelector("[data-sticky-rating-lockup]");
    this.ratingEl = this.querySelector("[data-sticky-rating]");
    this.reviewCountEl = this.querySelector("[data-sticky-review-count]");

    // State sync: the main form is the single source of truth. Initial values
    // are server-rendered in Liquid; this only handles updates on size change.
    this.productForm.addEventListener("dry:variant-selected", (e) => this.render(e.detail.data));

    // Reviews data from reviews.io, broadcast once the rating snippet loads.
    // detail = { data, rating, count }
    if (this.ratingEl || this.reviewCountEl) {
      document.addEventListener("reviewsio:snippet-rating-onload", (e) => {
        console.log('reviewsio:snippet-rating-onload', e)
        if (!e) return;
  
        const {rating, count} = e.detail || {};
        if (rating && this.ratingEl) {
          this.ratingEl.innerHTML = rating.toFixed(2);
        }
  
        if (count && this.reviewCountEl) {
          this.reviewCountEl.innerHTML = count.toLocaleString();
        }
  
  
        console.log('lockup', this.ratingLockupEl)
        this.ratingLockupEl?.removeAttribute('disabled');
        // TODO: populate the styled reviews display from e.detail
      });
    }

    this.submitButton = this.productForm.querySelector('[type="submit"]');

    // Add-to-cart: delegate to the real submit button so all of the main
    // form's bundle / petzyo-plan / update-cart logic is reused.
    this.button?.addEventListener("click", () => {
      this.submitButton?.click();
    });

    // Mirror the real submit button's loading state so the sticky button shows
    // the same spinner while an add / update is in flight.
    if (this.submitButton && this.button) {
      const syncLoading = () => {
        this.button.classList.toggle("loading", this.submitButton.classList.contains("loading"));
        // this.button.toggleAttribute("aria-disabled", this.submitButton.getAttribute("aria-disabled") === "true");
        this.button.toggleAttribute("disabled", this.submitButton.getAttribute("aria-disabled") === "true");
      };
      new MutationObserver(syncLoading).observe(this.submitButton, {
        attributes: true,
        // attributeFilter: ["class", "aria-disabled"],
        attributeFilter: ["class", "disabled"],
      });
    }

    this.initObserver();
  }

  render(data) {
    if (!data) return;
    if (this.nameEl && data.name) this.nameEl.textContent = data.name;
    if (this.weightEl) this.weightEl.textContent = data.weight ?? "";
    if (this.priceEl) this.priceEl.textContent = data.priceFormatted ?? "";
    if (this.button) this.button.disabled = data.available === false;
  }

  initObserver() {
    const submitWrapper = this.productForm.querySelector(".product-custom__form-wrap");
    if (!submitWrapper) return;

    const footer = document.querySelector('.petzyo-footer-section');

    // Track each target's latest intersection state; a single observer callback
    // often only includes the target that changed, so we can't read both from
    // one batch of entries.
    let submitIntersecting = true;
    let footerIntersecting = false;
    let showTimer;

    const update = () => {
      // Mirror DrySticky's guard so we don't fight the image popup.
      if (document.body.classList.contains("product-popup-opening")) return;

      // Hidden whenever the real CTA or the footer is in view.
      const shouldHide = submitIntersecting || footerIntersecting;
      clearTimeout(showTimer);

      if (shouldHide) {
        this.setAttribute('disabled', ''); // hide immediately
      } else {
        // Debounce the reveal so a fast scroll-through / overshoot doesn't flash
        // the bar in; cancelled above if the CTA or footer comes back into view.
        showTimer = setTimeout(() => this.removeAttribute('disabled'), 200);
      }
    };

    // Treat the strip behind the sticky header as "off screen" so the bar
    // shows once the real CTA slides under the header, not only when it clears
    // the viewport entirely.
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
      10
    ) || 65;

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === submitWrapper) submitIntersecting = entry.isIntersecting;
        else if (entry.target === footer) footerIntersecting = entry.isIntersecting;
      }
      update();
    }, { threshold: 0, rootMargin: `-${headerHeight}px 0px 0px 0px` });

    observer.observe(submitWrapper);
    if (footer) {
      observer.observe(footer);
    }
  }
}

customElements.define("product-sticky-atc", ProductStickyAtc);

class DryWeight extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');
    if (!this.select) return;
    this.select.addEventListener("change", (e) => {
      e.preventDefault();
      this.url = e.target.options[e.target.selectedIndex].getAttribute("data-url");
      window.location.href = this.url;
    });
  }
}

customElements.define("dry-weight", DryWeight);

class DryImages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.view = this.dataset.view;
    this.isDesktopView = this.view === 'desktop';
    this.isMobileView = !this.isDesktopView;
    this.images = this.querySelectorAll('.product-custom-thumbnails__list-item');
    // Tap-to-zoom is desktop only; mobile uses the inline carousel + thumbnail nav.
    if (this.isDesktopView) {
      this.images.forEach((image) => {
        image.addEventListener("click", this.openPopup.bind(this));
      });
    }

    this.closePopupBtn = document.querySelector('.js-popup-images-close');
    if (this.closePopupBtn) {
      this.closePopupBtn.addEventListener('click', this.closePopup.bind(this));
    }

    if (this.isDesktopView) {
      this.initDesktop();
    }
    else {
      this.initMobile();
    }

  }

  initDesktop() {
    console.log('init desktop')
    this.slide = document.querySelector('.product-custom-popup-images');
    this.flkty = new Flickity(this.slide, {
      cellAlign: "left",
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      wrapAround: true
    });
  }

  initMobile() {
    // Inline main carousel, navigated by the thumbnail grid below it. This is its
    // own element/instance, separate from the desktop zoom-popup carousel.
    this.slide = this.querySelector('[data-carousel]');
    if (!this.slide) return;

    this.flkty = new Flickity(this.slide, {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      wrapAround: true
    });

    this.navItems = this.querySelectorAll('[data-nav-index]');
    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        const index = parseInt(item.dataset.navIndex, 10);
        this.flkty.select(index);
      });
    });

    // Keep the active thumbnail in sync as the carousel changes.
    this.flkty.on('change', (index) => {
      this.navItems.forEach((item) => {
        item.classList.toggle('is-selected', parseInt(item.dataset.navIndex, 10) === index);
      });
    });

    // Open the zoom popup on a tap (Flickity suppresses staticClick after a drag/swipe).
    this.flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
      if (cellElement) this.showPopup(cellIndex);
    });
  }

  openPopup(e) {
    e.preventDefault();
    this.showPopup(e.currentTarget.getAttribute("data-index"));
  }

  showPopup(index) {
    this.currentIndex = index;
    // The popup carousel is owned by the desktop dry-images; resolve it directly so
    // this works whether opened from the desktop list or the mobile carousel.
    const popupFlkty = Flickity.data(document.querySelector('.product-custom-popup-images'));
    if (popupFlkty) popupFlkty.select(index);

    setTimeout(() => {
      if (document.querySelectorAll('dry-sticky').length > 0) {
        this.atcIsSticky = document.querySelector('dry-sticky').classList.contains('active');
        if (window.innerWidth < 750) {
          if (!this.atcIsSticky) {
            document.querySelector('dry-sticky').classList.add('active');
          }
  
          let stickyHeight = document.querySelector('dry-sticky').offsetHeight - 1;
          document.querySelector('.product-custom-popup').style.height = `calc(100% - ${stickyHeight}px)`;
        } else {
          document.querySelector('.product-custom-popup').style.height = `100%`;
        }
      }
      
      document.body.classList.add('product-popup-opening');
    }, 500);
  }

  closePopup() {
    if (document.querySelectorAll('dry-sticky').length > 0 && window.innerWidth < 750 && !this.atcIsSticky) {
      document.querySelector('dry-sticky').classList.remove('active');
    }

    document.body.classList.remove('product-popup-opening');
  }
}

customElements.define("dry-images", DryImages);

class Improvements extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this;
    this.openTrigger = this.container.querySelector('button[aria-has-popup]');
    this.openTrigger?.addEventListener("click", this.openPopup);

    this.closeBtns = document.querySelectorAll('close-review');
    this.closeBtns.forEach((btn) => {
      btn.addEventListener("click", this.closePopup.bind(this));
    });

    this.allReviews = document.querySelectorAll('all-reviews');
    this.allReviews.forEach((btn) => {
      btn.addEventListener("click", this.scrollToReviews.bind(this));
    });
  }

  openPopup() {
    document.body.classList.add('reviews-draw-opening');
  }

  closePopup() {
    document.body.classList.remove('reviews-draw-opening');
  }

  scrollToReviews() {
    this.closePopup();
    
    if (document.querySelectorAll('#yotpo-reviews-main-widget').length > 0) {
      const mainYotpoWidget = document.querySelector("#yotpo-reviews-main-widget");
      
      // Get the position relative to the viewport
      const rect = mainYotpoWidget.getBoundingClientRect();
      // Calculate the scroll position relative to the document
      const scrollTop = (window.pageYOffset + rect.top - 100);
      // Scroll smoothly to the widget
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  }
}

customElements.define("product-improvements", Improvements);

window.addEventListener("pageshow", () => {
  document.querySelectorAll("dry-weight select").forEach((select) => {
    let index = select.getAttribute("data-index");
    select.selectedIndex = index;
    select.style.opacity = "1";
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll('.all-reviews-url').length > 0) {
    document.querySelector('.all-reviews-url').addEventListener('click', (e) => {
      e.preventDefault();
      if (document.querySelectorAll('#yotpo-reviews-main-widget').length > 0) {
        const mainYotpoWidget = document.querySelector("#yotpo-reviews-main-widget");
        mainYotpoWidget.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = e.currentTarget.getAttribute('href');
      }
    })
  }
});